import { getRenderShapeProperty } from '../../../../../CanvasState/Helpers/Style/shape';

const getFill = shape => getRenderShapeProperty(
    shape,
    ['fill']
)?.toJS();

export default getFill;
